"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
function SvgPumpAlphaOutline(props) {
    return (React.createElement("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 32 32" }, props),
        React.createElement("path", { d: "M25 16a9 9 0 00-5-8V4h1V2H11v2h1v4a9 9 0 000 16.1V28h-1v2h10v-2h-1v-3.95A9 9 0 0025 16zM14 4h4v3.23a8.81 8.81 0 00-4 0zM9 16a7 7 0 117 7 7 7 0 01-7-7zm9 12h-4v-3.23a8.81 8.81 0 004 0z" })));
}
exports.default = SvgPumpAlphaOutline;
//# sourceMappingURL=PumpAlphaOutline.js.map